import { EditorSubmitReviewAction } from "./EditorSubmitReviewAction";
export default EditorSubmitReviewAction;
export * from "./EditorSubmitReviewAction";
